import queryString from 'utils/queryString';

const LANG_EN = 'en_us';
const LANG_ES = 'es_es';
const LANG_FR = 'fr_fr';
const LANG_PT = 'pt_pt';
const LANG_HY = 'hy_hy';
const LANG_TH = 'th_th';
const LANG_VI = 'vi_vi';
const LANG_IT = 'it_it';
const LANG_LV = 'lv_lv';
const LANG_SK = 'sk_sk';
const LANG_KM = 'km_km';
const LANG_BR = 'pt_br';
const LANG_LO = 'lo_lo';
/**
 * Function that returns the right user language
 * @return {string} - Returns our language string format, english as defaults.
 */
export default function getDefaultLanguage() {
  const { lang } = queryString.parse(document.location.search);
  // use url language param if exists,
  const language =
    lang ||
    // else use browser language,
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    // if IE or none of above, use OS language
    navigator.userLanguage;

  // format raw language string into our needed format
  switch (true) {
    case language.toUpperCase().includes('EN'):
      return LANG_EN;
    case language.toUpperCase().includes('ES'):
      return LANG_ES;
    case language.toUpperCase().includes('FR'):
      return LANG_FR;
    case language.toUpperCase().includes('BR'):
      return LANG_BR;
    case language.toUpperCase().includes('PT'):
      return LANG_PT;
    case language.toUpperCase().includes('HY'):
      return LANG_HY;
    case language.toUpperCase().includes('TH'):
      return LANG_TH;
    case language.toUpperCase().includes('VI'):
      return LANG_VI;
    case language.toUpperCase().includes('IT'):
      return LANG_IT;
    case language.toUpperCase().includes('LV'):
      return LANG_LV;
    case language.toUpperCase().includes('SK'):
      return LANG_SK;
    case language.toUpperCase().includes('KM'):
      return LANG_KM;
    case language.toUpperCase().includes('LO'):
      return LANG_LO;
    default:
      return LANG_EN;
  }
}

export const LANGUAGE_OPTIONS = [
  { value: LANG_EN, label: 'English' },
  { value: LANG_ES, label: 'Español' },
  { value: LANG_FR, label: 'Français' },
  { value: LANG_PT, label: 'Português' },
  { value: LANG_BR, label: 'Português (Brasil)' },
  { value: LANG_IT, label: 'Italiano' },
  { value: LANG_LV, label: 'Latviski' },
  { value: LANG_SK, label: 'Slovenský' },
  { value: LANG_HY, label: 'Հայերեն' },
  { value: LANG_TH, label: 'ไทย' },
  { value: LANG_VI, label: 'Tiếng Việt' },
  { value: LANG_KM, label: 'ភាសាខ្មែរ' },
  { value: LANG_LO, label: 'ລາວ' },
];
